module.exports = __webpack_public_path__ + "static/colvet-6b3da0956f7b1422e6c3a337290c6641.png";